const initialState = {
	"listaDescargas": [],
	"timestamp": false,
	"visible": false
};

export function descargasRdc(state = initialState, action) {
	switch (action.type) {
	case "DESCARGAS_LISTA":
		return {...state,
			"listaDescargas": action.listaDescargas
		};
	case "DESCARGAS_LISTA_ADD": 
		var lista = state.listaDescargas.slice();
		lista.push(action.descarga);
		return {...state,
			"visible": true,
			"timestamp": new Date().getTime(),
			"listaDescargas": lista
		};
	case "DESCARGAS_LISTA_UPDATE": 
		var lista = state.listaDescargas.slice();
		lista.map((item) => {
			if(item.id == action.descarga.id) {
				item.completo = action.descarga.completo;
				if(action.descarga.nombre) {
					item.nombre = action.descarga.nombre;
				}
				if(action.descarga.error) {
					item.error = true;
				}	
			}
		});
		return {...state,
			"visible": true,
			"timestamp": new Date().getTime(),
			"listaDescargas": lista
		};
	case "DESCARGAS_LISTA_REMOVE": 
		return {...state,
			"listaDescargas": state.listaDescargas.indexOf(action.posicion)
		};
	case "DESCARGAS_LISTA_SHOW": 
		return {...state,
			"visible": true
		};
	case "DESCARGAS_LISTA_HIDE":
		return {...state,
			"visible": false
		};
	case "DESCARGAS_SET_EVENT":
		return {...state,
			"evento":action.evento
		};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/descargas/reducer.js